import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import InfoPopUp from "../../Common/InfoPopUp";
import { OptionDataContenxt } from "./OptionChartDashboard";
import InfoIcon from "@mui/icons-material/Info";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { useTradingColors } from "../Spot/tradingColorConfig";
import OrderBookTooltip, { formatOrderBookNumber } from "../../Common/OrderBookTooltip";
import "../Spot/Spot.css";

const title = "Orderbook";
const description =
  "Sell offers are displayed on top in red color, and Buy offers are displayed at the bottom in green color. The right side of the order book is displaying the current 50 trades that took place in the market in the last 24 hours.";

const currencySymbols = {
  INR: "₹",
  USD: "$",
  USDT: "$",
  AED: "د.إ",
  EUR: "€",
  SGD: "S$",
};

const OptionOrderBook = () => {
  const {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    currencycode,
    basecurrency,
    lowPrice,
    highPrice,
    assetpair,
    refresh,
    setSellData,
    setBuyData,
    setLastAskItem,
    setFirstBidItem,
  } = useContext(OptionDataContenxt);

  const { upColor, downColor } = useTradingColors();
  const theme = localStorage.getItem("theme");
  const tableContentRef = useRef(null);
  const { brokerBasicInfo } = useSelector((state) => state);

  const [biddata, setBiddata] = useState([]);
  const [askdata, setAskdata] = useState([]);

    useEffect(() => {
    if (askdata && askdata.length > 0) {
      const sortedAsk = [...askdata].sort((a, b) => b.price - a.price);
      setLastAskItem(sortedAsk[sortedAsk.length - 1]);
    }
    }, [askdata]);

    useEffect(() => {
    if (biddata && biddata.length > 0) {
      const sortedBid = [...biddata].sort((a, b) => a.price - b.price);
      setFirstBidItem(sortedBid[0]);
    }
    }, [biddata]);

    const [tradep, setTradep] = useState(6);
  const [data, setData] = useState({});
  const [marketTradeRecords, setMarketTradeRecords] = useState([]);
  const [show, setShow] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [hoverInfo, setHoverInfo] = useState(null);

  const handleRowMouseEnter = (type, index, targetEl) => {
    updateHover(type, index, targetEl);
  };

  const handleRowMouseMove = (type, index, targetEl) => {
    if (!hoverInfo || hoverInfo.type !== type || hoverInfo.index !== index) {
      updateHover(type, index, targetEl);
    }
  };

  const updateHover = (type, index, targetEl) => {
    if (!targetEl) return;
    const rect = targetEl.getBoundingClientRect();
    const prc = parseInt(tradep || 6);

    let sumBase = 0;
    let sumQuote = 0;

    if (type === "ask") {
      for (let i = index; i < asksWithDepth.length; i++) {
        const item = asksWithDepth[i];
        const p = parseFloat(item.price) || 0;
        const a = parseFloat(item.amount) || 0;
        sumBase += a;
        sumQuote += p * a;
      }
    } else {
      for (let i = 0; i <= index && i < bidsWithDepth.length; i++) {
        const item = bidsWithDepth[i];
        const p = parseFloat(item.price) || 0;
        const a = parseFloat(item.amount) || 0;
        sumBase += a;
        sumQuote += p * a;
      }
    }

    const avgPrice = sumBase > 0 ? sumQuote / sumBase : 0;

    setHoverInfo({
      type,
      index,
      rect,
      avgPrice: formatOrderBookNumber(avgPrice, prc),
      sumBase: formatOrderBookNumber(sumBase, prc),
      sumQuote: formatOrderBookNumber(sumQuote, 6),
    });
  };

  const handleClose = () => setShow(false);
  const accessToken = localStorage.getItem("access_token");

  const websocketRef = useRef(null);
  const [stompClient, setStompClient] = useState(null);
  const webSocketEndPoint =
    "https://options-socket.paybito.com/oSocketStream/ws";
  const topic = "/user/topic/stream";
  let reqNo = Math.floor(Math.random() * 1000) + 1;

  const connect = () => {
    if (!accessToken) return;
    let ws = new SockJS(webSocketEndPoint);
    let client = Stomp.over(ws);
    client.connect(
      {},
      () => {
        websocketRef.current.socket = client;
        client.subscribe(topic, (sdkEvent) => {
          const message = JSON.parse(sdkEvent.body);
          if (websocketRef.current.subscribeMessage) {
            websocketRef.current.subscribeMessage(message);
          }
          onMessageReceived(sdkEvent);
        });
      },
      (error) => {
        console.error("WebSocket Error:", error);
        setTimeout(connect, 5000);
      }
    );
    client.debug = null;
    setStompClient(client);
  };

  const disconnect = () => {
    if (stompClient) stompClient.disconnect();
  };

  const send = (message) => {
    if (stompClient)
      stompClient.send("/app/sendRequest", {}, JSON.stringify(message));
  };

  const onMessageReceived = (message) => {
    const obj = JSON.parse(message.body);
    const parsedData = obj;
    const tradeHistoryData = obj;

    setData((prevData) => {
      if (parsedData.tR) {
        const data = parsedData.tR;
        const roc = parseFloat(data.roc).toFixed(2);
        return {
          ...prevData,
          ltpdata: data.ltp,
          lowprice: parseFloat(data.lowPrice).toFixed(2),
          highprice: parseFloat(data.highPrice).toFixed(2),
          ACTION: data.action,
          rocdata: roc,
          volumndata: parseFloat(data.volume).toFixed(2),
          rocreact: roc > 0,
          negetive: roc < 0,
          react: data.action === "sell",
        };
      }
      return prevData;
    });

    if (tradeHistoryData.e === "trade") {
      let updatedRecords = [...marketTradeRecords];
      tradeHistoryData.tH.forEach((trade) => {
        const tradeItem = {
          quantity: parseFloat(trade.quantity).toFixed(2),
          price: parseFloat(trade.price).toFixed(2),
          timestamp: trade.timestamp,
          side: trade.side,
          newTrade: trade.side === "ASK" ? "newask" : "newbid",
        };
        updatedRecords.unshift(tradeItem);
      });
      if (updatedRecords.length > 100)
        updatedRecords = updatedRecords.slice(0, 100);
      setMarketTradeRecords(updatedRecords);
    }
  };

  const serverSentEventForOrderbookAsk = async () => {
    try {
      const response = await axios.get(
        `https://options-socket.paybito.com/oSocketStream/api/depth?symbol=${assetpair}&limit=25`,
        {
          headers: { authorization: `BEARER ${accessToken}` },
        }
      );
      setAskdata([...response.data.ask].sort((a, b) => b.price - a.price));
      setBiddata([...response.data.bid].sort((a, b) => b.price - a.price));

      websocketRef.current = { socket: null, subscribeMessage: null };
      connect();

      websocketRef.current.subscribeMessage = (message) => {
        if (!message) return;
        const orderbookData = message;
        if (orderbookData.e === "depthUpdate") {
          setAskdata((prev) => {
            let updated = [...prev];
            orderbookData.ask?.forEach((ask) => {
              if (ask.action === "NEW" && ask.side === "ASK") {
                updated.push({
                  price: parseFloat(ask.price).toFixed(tradep),
                  amount: parseFloat(ask.quantity).toFixed(tradep),
                  newly: true,
                });
              } else if (ask.action === "CHANGE") {
                updated = updated.map((item) =>
                  item.price === parseFloat(ask.price)
                    ? { ...item, amount: ask.quantity, newly: true }
                    : item
                );
              } else if (ask.action === "DELETE") {
                updated = updated.filter(
                  (item) => item.price !== parseFloat(ask.price)
                );
              }
            });
            return [...updated].sort((a, b) => b.price - a.price).slice(-50);
          });

          setBiddata((prev) => {
            let updated = [...prev];
            orderbookData.bid?.forEach((bid) => {
              if (bid.action === "NEW" && bid.side === "BID") {
                updated.push({
                  price: parseFloat(bid.price).toFixed(tradep),
                  amount: parseFloat(bid.quantity).toFixed(tradep),
                  newly: true,
                });
              } else if (bid.action === "CHANGE") {
                updated = updated.map((item) =>
                  item.price === parseFloat(bid.price)
                    ? { ...item, amount: bid.quantity, newly: true }
                    : item
                );
              } else if (bid.action === "DELETE") {
                updated = updated.filter(
                  (item) => item.price !== parseFloat(bid.price)
                );
              }
            });
            return [...updated].sort((a, b) => b.price - a.price).slice(0, 50);
          });
        }
      };
    } catch (error) {
      console.error("Error fetching order book:", error);
    }
  };

  useEffect(() => {
    setFinalBiddata(biddata);
    setFinalAskdata(askdata);
  }, [biddata, askdata]);

  // ── Calculate Binance-style Order Book Buy/Sell Ratio ──
  const { buyPercent, sellPercent, buyBarWidth, sellBarWidth } = React.useMemo(() => {
    if (!biddata?.length && !askdata?.length) {
      return { buyPercent: "50.00", sellPercent: "50.00", buyBarWidth: 50, sellBarWidth: 50 };
    }

    let totalBid = 0;
    for (let i = 0; i < biddata.length; i++) {
      totalBid += parseFloat(biddata[i]?.amount) || 0;
    }

    let totalAsk = 0;
    for (let i = 0; i < askdata.length; i++) {
      totalAsk += parseFloat(askdata[i]?.amount) || 0;
    }

    const total = totalBid + totalAsk;
    if (total <= 0) {
      return { buyPercent: "50.00", sellPercent: "50.00", buyBarWidth: 50, sellBarWidth: 50 };
    }

    const buyRatio = (totalBid / total) * 100;
    const sellRatio = (totalAsk / total) * 100;

    return {
      buyPercent: buyRatio.toFixed(2),
      sellPercent: sellRatio.toFixed(2),
      buyBarWidth: Math.min(100, Math.max(0, buyRatio)),
      sellBarWidth: Math.min(100, Math.max(0, sellRatio)),
    };
  }, [biddata, askdata]);

  // ── Calculate Binance-style Relative Order Size Overlays for Asks ──
  const asksWithDepth = React.useMemo(() => {
    if (!askdata || !askdata.length) return [];

    const sortedAsks = [...askdata].sort(
      (a, b) => parseFloat(b.price) - parseFloat(a.price)
    );

    let maxAmount = 0;
    sortedAsks.forEach((item) => {
      const amt = parseFloat(item.amount) || 0;
      if (amt > maxAmount) maxAmount = amt;
    });
    if (maxAmount <= 0) maxAmount = 1;

    return sortedAsks.map((item) => {
      const amt = parseFloat(item.amount) || 0;
      const percent = Math.min(100, Math.max(2, (amt / maxAmount) * 100));
      return {
        ...item,
        depthPercent: percent.toFixed(1),
      };
    });
  }, [askdata]);

  // ── Calculate Binance-style Relative Order Size Overlays for Bids ──
  const bidsWithDepth = React.useMemo(() => {
    if (!biddata || !biddata.length) return [];

    const sortedBids = [...biddata].sort(
      (a, b) => parseFloat(b.price) - parseFloat(a.price)
    );

    let maxAmount = 0;
    sortedBids.forEach((item) => {
      const amt = parseFloat(item.amount) || 0;
      if (amt > maxAmount) maxAmount = amt;
    });
    if (maxAmount <= 0) maxAmount = 1;

    return sortedBids.map((item) => {
      const amt = parseFloat(item.amount) || 0;
      const percent = Math.min(100, Math.max(2, (amt / maxAmount) * 100));
      return {
        ...item,
        depthPercent: percent.toFixed(1),
      };
    });
  }, [biddata]);

  useEffect(() => {
    serverSentEventForOrderbookAsk();
    return () => disconnect();
  }, [assetpair]);

  const getPrice = (m) => parseFloat(m.price).toFixed(tradep);
  const getAmount = (m) => parseFloat(m.amount).toFixed(tradep);

  const handleSellClick = (data) => setSellData(data);
  const handleBuyClick = (data) => setBuyData(data);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: "hidden" }}>
      {/* Table Header */}
      <div
        className="table_content"
        style={{
          height: "30px",
          minHeight: "30px",
          overflow: "hidden",
          paddingBottom: 0,
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed" }}>
          <colgroup>
            <col style={{ width: "34%" }} />
            <col style={{ width: "33%" }} />
            <col style={{ width: "33%" }} />
          </colgroup>
          <thead>
            <tr>
              <th
                className="text-start position-relative"
                style={{
                  color: theme === "light" ? "black" : "",
                  whiteSpace: "nowrap",
                }}
              >
                Amount
                <InfoIcon
                  style={{
                    color: "#a8a1a1",
                    cursor: "pointer",
                    marginLeft: "4px",
                    fontSize: "15px",
                    verticalAlign: "middle",
                  }}
                  onClick={() => setShow(true)}
                />
              </th>
              <th
                className="text-end"
                style={{
                  color: theme === "light" ? "black" : "",
                  whiteSpace: "nowrap",
                }}
              >
                Price
              </th>
              <th
                className="text-end"
                style={{
                  color: theme === "light" ? "black" : "",
                  whiteSpace: "nowrap",
                  paddingRight: "8px",
                }}
              >
                Total
              </th>
            </tr>
          </thead>
        </table>
      </div>

      {/* Asks Table */}
      <div
        className="table_content reverse_table"
        ref={tableContentRef}
        onMouseLeave={() => setHoverInfo(null)}
        onScroll={() => setHoverInfo(null)}
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: 0,
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed" }} className="orderbook_table">
          <colgroup>
            <col style={{ width: "34%" }} />
            <col style={{ width: "33%" }} />
            <col style={{ width: "33%" }} />
          </colgroup>
          <tbody>
            {asksWithDepth.length > 0 ? (
              asksWithDepth.map((d, i) => {
                const isHovered = hoverInfo?.type === "ask" && i >= hoverInfo.index;
                return (
                  <tr
                    key={`ask-${i}`}
                    className={`orderbook-depth-ask ${d.newly ? "bg-flash-red" : ""} ${
                      isHovered
                        ? theme === "light"
                          ? "orderbook-row-hovered-light"
                          : "orderbook-row-hovered"
                        : ""
                    }`}
                    style={{ "--depth": `${d.depthPercent}%` }}
                    onMouseEnter={(e) => handleRowMouseEnter("ask", i, e.currentTarget)}
                    onMouseMove={(e) => handleRowMouseMove("ask", i, e.currentTarget)}
                  >
                    <td className="text-start" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {getAmount(d)}
                    </td>
                    <td
                      className="text-end"
                      style={{ color: downColor, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      onClick={() => handleSellClick(getPrice(d))}
                    >
                      {getPrice(d)}
                    </td>
                    <td className="text-end" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {(getAmount(d) * getPrice(d)).toFixed(tradep)}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mid Market Price / 24H High-Low */}
      <div
        className="sp-highlow"
        style={{
          height: "28px",
          minHeight: "28px",
          maxHeight: "28px",
          flexShrink: 0,
          backgroundColor: "var(--body-color-less)",
        }}
      >
        {currencySymbols[basecurrency?.toUpperCase()] && (
          <span style={{ color: "#f1b900" }}>
            {currencySymbols[basecurrency?.toUpperCase()]}
          </span>
        )}
        <span style={{ color: "#f1b900", paddingRight: "5px" }}>
          {chartData?.ctp}
        </span>
        <span className="font-sm ml-2" id="pricegreen">
          {toggle ? (
            <span style={{ fontSize: "10px", color: upColor }}>
              <ArrowUpwardIcon sx={{ fontSize: "12px" }} /> 24H H: {highPrice}
            </span>
          ) : (
            <span style={{ fontSize: "10px", color: downColor }}>
              <ArrowDownwardIcon sx={{ fontSize: "12px" }} /> 24H L: {lowPrice}
            </span>
          )}
        </span>

        <a
          href={`/orderbook/${currencycode || "BTC"}_${basecurrency || "USDT"}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Open Order Book"
          className="orderbook-chevron-btn"
        >
          <ChevronRightIcon sx={{ fontSize: "18px" }} />
        </a>
      </div>

      {/* Bids Table */}
      <div
        className="table_content"
        onMouseLeave={() => setHoverInfo(null)}
        onScroll={() => setHoverInfo(null)}
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: 0,
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed", marginTop: "4px" }} className="orderbook_table">
          <colgroup>
            <col style={{ width: "34%" }} />
            <col style={{ width: "33%" }} />
            <col style={{ width: "33%" }} />
          </colgroup>
          <tbody>
            {bidsWithDepth.length > 0 ? (
              bidsWithDepth.map((d, i) => {
                const isHovered = hoverInfo?.type === "bid" && i <= hoverInfo.index;
                return (
                  <tr
                    key={`bid-${i}`}
                    className={`orderbook-depth-bid ${d.newly ? "bg-flash-green" : ""} ${
                      isHovered
                        ? theme === "light"
                          ? "orderbook-row-hovered-light"
                          : "orderbook-row-hovered"
                        : ""
                    }`}
                    style={{ "--depth": `${d.depthPercent}%` }}
                    onMouseEnter={(e) => handleRowMouseEnter("bid", i, e.currentTarget)}
                    onMouseMove={(e) => handleRowMouseMove("bid", i, e.currentTarget)}
                  >
                    <td className="text-start" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {getAmount(d)}
                    </td>
                    <td
                      style={{ color: upColor, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      className="text-end"
                      onClick={() => handleBuyClick(getPrice(d))}
                    >
                      {getPrice(d)}
                    </td>
                    <td className="text-end" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {(getAmount(d) * getPrice(d)).toFixed(tradep)}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* BUY / SELL RATIO BAR */}
      <div
        className="orderbook-ratio-bar"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          width: "100%",
          padding: "4px 8px",
          boxSizing: "border-box",
          userSelect: "none",
          flexShrink: 0,
          borderTop: theme === "light" ? "1px solid rgba(0,0,0,0.06)" : "1px solid rgba(255,255,255,0.05)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0, whiteSpace: "nowrap" }}>
          <span style={{ color: theme === "light" ? "#707a8a" : "#848e9c", fontWeight: 700, fontSize: "11px" }}>B</span>
          <span style={{ color: upColor, fontWeight: 600, fontSize: "11px" }}>{buyPercent}%</span>
        </div>

        <div
          className="orderbook-ratio-track"
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            height: "4px",
            margin: "0 8px",
            gap: "2px",
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          <div
            className="orderbook-ratio-buy"
            style={{
              width: `${buyBarWidth}%`,
              height: "100%",
              backgroundColor: upColor,
              borderRadius: "2px",
              transition: "width 0.3s ease-in-out",
            }}
          />
          <div
            className="orderbook-ratio-sell"
            style={{
              width: `${sellBarWidth}%`,
              height: "100%",
              backgroundColor: downColor,
              borderRadius: "2px",
              transition: "width 0.3s ease-in-out",
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0, whiteSpace: "nowrap" }}>
          <span style={{ color: downColor, fontWeight: 600, fontSize: "11px" }}>{sellPercent}%</span>
          <span style={{ color: theme === "light" ? "#707a8a" : "#848e9c", fontWeight: 700, fontSize: "11px" }}>S</span>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />

      <OrderBookTooltip
        hoverInfo={hoverInfo}
        baseCurrency={currencycode}
        quoteCurrency={basecurrency}
        theme={theme}
      />
    </div>
  );
};

export default OptionOrderBook;
